<script setup>
import {formatSum} from '@shared-utils/helpers'
import TdId from '@shared-components/ui/table/TdId.vue'
import AlertInfoSimple from '@shared-components/ui/alerts/AlertInfoSimple.vue'
import ListWrapper from '@shared-components/ui/ListWrapper.vue'
import {onMounted, ref} from 'vue'
import dayjs from 'dayjs'

const props = defineProps({
  getRequests: {
    type: Function,
    required: true,
  },
  companyHash: {
    type: String,
    default: '',
  },
  todayDate: {
    type: String,
    default: '',
    required: true,
  },
})

// Refs
const activeTopUpRequests = ref([])
const topUpRequestsLoading = ref(false)

// Methods
onMounted(() => handleGetTopUpRequests)
const handleGetTopUpRequests = async () => {
  topUpRequestsLoading.value = true

  const filters = {
    company_hash: props.companyHash,
    statuses: ['in_progress', 'delayed', 'open'],
    date_from: '2023-07-01',
    date_to: dayjs().format('YYYY-MM-DD'),
    with: ['entity'],
  }

  try {
    const {data} = await props.getRequests(filters)
    activeTopUpRequests.value = data
  } catch (error) {
    notify({type: 'error', text: error?.data?.message})
  } finally {
    topUpRequestsLoading.value = false
  }
}

defineExpose({handleGetTopUpRequests})
</script>

<template>
  <alert-info-simple>
    <list-wrapper
      empty-list-message="No active requests"
      last-page
      :loading="topUpRequestsLoading"
      :list-length="activeTopUpRequests?.length"
      :list-height="activeTopUpRequests?.length >= 3 ? '200' : 'content'"
    >
      <table class="table m-0">
        <thead>
          <tr>
            <th>ID</th>
            <th>Title</th>
            <th>Amount</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="request in activeTopUpRequests" :key="request.id">
            <td-id :platform="request.platform">
              {{ request.id }}
            </td-id>
            <td>
              <template v-if="request?.entity">
                <div class="text-ellipsis">{{ request?.entity?.title }}</div>
                <small v-if="request?.entity?.external_id" class="text-muted text-ellipsis"
                  >{{ request?.entity?.external_id }}
                </small>
              </template>
            </td>
            <td>{{ formatSum(request.amount) }}</td>
          </tr>
        </tbody>
      </table>
    </list-wrapper>
  </alert-info-simple>
</template>
